export interface SizeBucket {
	label: string;
	greaterEqual: number;
	/** Absent on the open-ended top bucket. */
	lowerEqual?: number;
}

export const LINKEDIN_SIZE_BUCKETS: SizeBucket[] = [
	{ label: "Self-employed", greaterEqual: 1, lowerEqual: 1 },
	{ label: "1-10", greaterEqual: 2, lowerEqual: 10 },
	{ label: "11-50", greaterEqual: 11, lowerEqual: 50 },
	{ label: "51-200", greaterEqual: 51, lowerEqual: 200 },
	{ label: "201-500", greaterEqual: 201, lowerEqual: 500 },
	{ label: "501-1,000", greaterEqual: 501, lowerEqual: 1000 },
	{ label: "1,001-5,000", greaterEqual: 1001, lowerEqual: 5000 },
	{ label: "5,001-10,000", greaterEqual: 5001, lowerEqual: 10000 },
	{ label: "10,001+", greaterEqual: 10001 },
];

export interface ScoreSizeItem {
	points: number;
	description?: string;
	lowerEqual?: number;
	greaterEqual?: number;
	type?: string | null;
}

/**
 * The bucket a stored range represents. Ranges the user configured before (or
 * that the AI generated) rarely land on a bucket boundary, so they snap to every
 * bucket they overlap — the tiers a user sees are then exactly what scores.
 */
export const bucketsOfItem = (item: ScoreSizeItem): string[] => {
	const from = item.greaterEqual ?? 0;
	const to = item.lowerEqual ?? Number.MAX_SAFE_INTEGER;

	return LINKEDIN_SIZE_BUCKETS.filter(
		(bucket) => bucket.greaterEqual <= to && (bucket.lowerEqual ?? Number.MAX_SAFE_INTEGER) >= from
	).map((bucket) => bucket.label);
};

/** Unclaimed ranges in LinkedIn order; only the UI's four scoring tiers claim ranges. */
export const unassignedSizeBucketLabels = (items: ScoreSizeItem[]): string[] => {
	const claimed = new Set<string>();

	for (const item of items) {
		if (![3, 2, 1, 0].includes(item.points)) {
			continue;
		}

		for (const label of bucketsOfItem(item)) {
			claimed.add(label);
		}
	}

	return LINKEDIN_SIZE_BUCKETS.filter((bucket) => !claimed.has(bucket.label)).map(
		(bucket) => bucket.label
	);
};
